import { DownOutlined, PlusCircleOutlined } from '@ant-design/icons'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Button, Dropdown, Menu, Spin, Table } from 'antd';
import Axios from '../../../services/AxiosInterceptor';
// import AttendanceCalendar from './AttendanceCalendar';

 const StaffLists = () => {
  const navigate = useNavigate();
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
    const handlestaffAdd=()=>{
      navigate("/addstaff")
    }
console.log(staffList)
// const handleMenuClick = async(e, record) => {
//   if (e.key === 'edit') {
//     navigate(`/edit-staff/${record._id}`);
//   } else if (e.key === 'delete') {
//     const response = await Axios.post('api/staff-list-delete', {
//       method: "POST",
//       headers: {
//         'Content-Type': 'application/json',  
//       },
//       body: JSON.stringify({ id: record._id })  
//     });
//   if(response){
//     window.location.reload();
//   }
//   }
// };
const handleMenuClick = async (e, record) => {
  if (e.key === 'edit') {
    navigate(`/edit-staff/${record._id}`);

  } else if (e.key === 'delete') {
    try {
      const response = await Axios.post(
        'api/staff-list-delete',
        { id: record._id }, // <-- data correctly sent here
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data) {
        window.location.reload();
      }
    } catch (error) {
      console.error("Delete failed:", error);
    }
  }
};

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    key: 'phone',
  },
  {
    title: 'Age',
    dataIndex: 'age',
    key: 'age',
  },
 
  {
    title: 'Address',
    dataIndex: 'address',
    key: 'address',
  },
  {
    title: 'Department',
    dataIndex: 'department',
    key: 'department',
  },
  {
    title: 'Position',
    dataIndex: 'position',
    key: 'position',
  },
  {
    title: 'Start Date',
    dataIndex: 'startDate',
    key: 'startDate',
  },
  {
    title: 'Actions',
    key: 'actions',
    render: (text, record) => (
      <Dropdown
        overlay={
          <Menu onClick={(e) => handleMenuClick(e, record)}>
            <Menu.Item key="edit">Edit</Menu.Item>
            <Menu.Item key="delete">Delete</Menu.Item>
          </Menu>
        }
        trigger={['click']}
      >
        <Button>
          Actions <DownOutlined />
        </Button>
      </Dropdown>
    ),
  },
];

// const fetchStaffData = async () => {
//   try {
//     const response = await Axios.post('/api/staff'); 
//     console.log("response",response)
//     if (!response.ok) {
//       throw new Error('Failed to fetch staff data');
//     }
//     const data = await response.json();
//     const reversedData = data.reverse();

//     setStaffList(reversedData); 
//   } catch (error) {
//     setError(error.message); 
//   } finally {
//     setLoading(false); 
//   }
// };
    
const fetchStaffData = async () => {
  try {
    const response = await Axios.get('/api/staff');

    console.log("response", response);

    const data = response.data; // Axios JSON body

    const reversedData = data.reverse();
    setStaffList(reversedData);

  } catch (error) {
    setError(error.message);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
    fetchStaffData(); 
    }, []); 


console.log(error)
    
    if (loading) {
      return <Spin/>;
    }

  return (
    <div>
<button onClick={handlestaffAdd} style={{marginTop:"50px",marginLeft:"10px",border:"1px solid orange",borderRadius:"5px",background:"orange",color:"white",padding:"3px"}}>Add Staff <PlusCircleOutlined /></button>
<div style={{ overflowX: 'auto',marginTop:"30px",padding:"10px" }}>
      <Table 
        columns={columns} 
        dataSource={staffList} 
        // pagination={false}  // Optional: Disable pagination for better responsiveness
        // scroll={{ x: 'max-content' }}  // Allows horizontal scrolling on smaller screens
        bordered
        size="middle"
        responsive
      />
    </div>
    </div>
  )
}

export default StaffLists;

